import React from 'react';
import { Smartphone, CreditCard, ArrowRight, ArrowDown, Server, Printer, Landmark } from 'lucide-react';
import { PublicSection, Reveal } from '@/components/public';

const STEPS = [
  { icon: Smartphone, title: 'Customer Orders', text: 'On your Hungry Canadian web or app storefront' },
  { icon: CreditCard, title: 'Stripe Payment', text: 'Card processed & payout queued to your bank' },
  { icon: Landmark, title: 'Hungry Canadian Core', text: 'CAD taxes (GST/PST/HST) applied automatically' },
  { icon: Server, title: 'POS / Deliverect Cloud API', text: 'Order injected into your existing system' },
  { icon: Printer, title: 'Thermal Printers', text: 'Epson Wi-Fi/BT & Star CloudPRNT fire the ticket' },
];

export default function OrderFlowDiagram() {
  return (
    <PublicSection
      id="order-flow"
      testId="order-flow-section"
      variant="default"
      align="center"
      eyebrow="Order Architecture"
      title="From tap to ticket, in seconds"
      description="One connected pipeline — no tablets to babysit, no orders to re-key."
      padTop="pt-16 md:pt-20"
      padBottom="pb-16 md:pb-20"
    >
      <Reveal>
        <ol
          data-testid="order-flow-diagram"
          className="flex flex-col lg:flex-row items-stretch justify-center gap-2 lg:gap-0"
        >
          {STEPS.map(({ icon: Icon, title, text }, i) => (
            <React.Fragment key={title}>
              <li
                data-testid={`order-flow-step-${i + 1}`}
                className="flex-1 flex flex-col items-center text-center bg-card border border-border p-5 lg:p-6 max-w-sm w-full mx-auto lg:mx-0 lg:max-w-none"
              >
                <span className="relative inline-flex w-12 h-12 items-center justify-center bg-primary/10 text-primary mb-3.5">
                  <Icon className="w-6 h-6" strokeWidth={2} />
                  <span className="absolute -top-2 -right-2 w-5 h-5 rounded-full bg-primary text-primary-foreground text-[10px] font-black flex items-center justify-center">
                    {i + 1}
                  </span>
                </span>
                <p className="text-sm font-heading font-bold text-foreground leading-tight">{title}</p>
                <p className="mt-1.5 text-xs text-muted-foreground leading-relaxed">{text}</p>
              </li>
              {i < STEPS.length - 1 && (
                <li aria-hidden className="flex items-center justify-center px-1.5 py-1 text-primary">
                  <ArrowRight className="hidden lg:block w-5 h-5" strokeWidth={2.5} />
                  <ArrowDown className="lg:hidden w-5 h-5" strokeWidth={2.5} />
                </li>
              )}
            </React.Fragment>
          ))}
        </ol>
      </Reveal>
    </PublicSection>
  );
}
